import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/inventory/bulk/upload/upload_info", payload);
  },
};
